import { render, staticRenderFns } from "./CourseCategories.vue?vue&type=template&id=06bf6def&scoped=true&"
import script from "./CourseCategories.vue?vue&type=script&lang=js&"
export * from "./CourseCategories.vue?vue&type=script&lang=js&"
import style0 from "./CourseCategories.vue?vue&type=style&index=0&id=06bf6def&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf6def",
  null
  
)

export default component.exports